module.exports = __webpack_public_path__ + "img/1.3f6b8560.png";